
import React from 'react';
import { Link } from 'react-router-dom';
import OptimizedImage from '@/components/ui/optimized-image';
import { AspectRatio } from '@/components/ui/aspect-ratio';

interface KayttokohteetCardProps {
  title: string;
  description: string;
  imagePath: string;
  bgColor?: string;
  link?: string;
}

const KayttokohteetCard: React.FC<KayttokohteetCardProps> = ({ 
  title, 
  description, 
  imagePath, 
  bgColor = "bg-blue-50", 
  link 
}) => {
  const cardContent = (
    <>
      <div className="rounded-lg overflow-hidden mb-3">
        <AspectRatio ratio={16/9}>
          <OptimizedImage 
            src={imagePath} 
            alt={title} 
            className="w-full h-full"
            objectFit="cover"
            loading="lazy"
            quality={80}
            aspectRatio={16/9}
          />
        </AspectRatio>
      </div>
      <h3 className="font-semibold text-blue-800 text-lg mb-1">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </>
  );

  const cardClasses = `${bgColor} p-4 rounded-xl transition-shadow hover:shadow-md group overflow-hidden`;

  return link ? (
    <Link to={link} className={cardClasses}>
      {cardContent}
    </Link>
  ) : (
    <div className={cardClasses}>
      {cardContent}
    </div>
  );
};

export default KayttokohteetCard;
